import { Modal } from '@/components/dialogs/modal'

interface AdaptationModalProps {
  isOpen: boolean
  setOpen: (value: boolean) => void
}

export function AdaptationModal({ isOpen, setOpen }: AdaptationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      title={'Disciplina(s) em Adaptação: O que significa?'}
      hiddenFooter={true}
    >
      <div className="flex flex-col gap-3">
        <p>
          Parabéns! Devido ao seu aproveitamento de estudos,{' '}
          <strong>
            você foi alocado(a) em um módulo mais avançado do curso.
          </strong>
        </p>

        <p>
          A situação{' '}
          <span className="text-[var(--brand-blue-1)] font-bold">
            "Adaptação"
          </span>{' '}
          indica as disciplinas que, apesar de não terem sido dispensadas, não
          farão parte da sua grade curricular regular nos primeiros períodos.
        </p>

        <ul className="list-disc pl-6 font-bold">
          <li>
            Isso é bom! Significa que você tem a chance de antecipar a conclusão
            do seu curso.
          </li>
          <li className="font-normal">
            Você deverá{' '}
            <span className="text-[var(--brand-blue-1)] font-bold">
              solicitar a inclusão dessas disciplinas de Adaptação ao longo do
              curso,
            </span>{' '}
            seguindo a orientação da coordenação. Elas serão ofertadas em um
            período especial para você.
          </li>
        </ul>
        <p>
          Fique atento(a) às orientações futuras sobre como solicitar essas
          disciplinas.
        </p>
      </div>
    </Modal>
  )
}
